module.exports = __webpack_public_path__ + "img/arrow-chart.3bfea3ee.svg";